import { defineStore } from 'pinia';

// 当前选中搜索司机ID
export const useTaxStore = defineStore('tax', {
  state: () => ({
    activeDriverId: '0',
    switch: false,
  }),
  actions: {
    setActiveDriver(driverId: string) {
      this.activeDriverId = driverId;
    },
    setTaxSwitch(taxSwitch: boolean) {
      this.switch = taxSwitch;
    },
  },
});
